<div (gtwClickOutside)="closeMenuPanel($event)">
    <div class="nav-panel ap-navigation-panel">
        <gtw-tasks 
            [app_navigation]="appNavigation" 
            (clickDomain)="showTasksAndCategories($event)"
            (load-screens)="showScreens($event)">
        </gtw-tasks>
    </div>
    
    @if (!isMenuPanelClosed) {
<div class="nav-panel sub-task-panel">    
        <div class="menuSearch">
            <span class="panel-title"> {{domainName}} </span>
        
            <div class="searchContainer">
                <ap-search
                    [searchType]="'secondary'"
                    [placeholder]="'Search'"
                    [filtered]="false"
                    [styleClass]="'gtw-nav-search'"
                    [ariaLabel]="'Search tax types'"
                    [(ngModel)]="taxTypeSearchTerm"
                    (onSearch)="onAppkitSearch($event, 'tax-type')"
                    (onKeydown)="onAppkitSearch($event, 'tax-type')"
                    (onClear)="onAppkitClear('tax-type')">
                </ap-search>
            </div>
            <div class="menu-settings-wrapper" (gtwClickOutside)="menuSettings = false;">
                <span class="Appkit4-icon Appkit4-icon icon-vertical-more-fill settingDropdown" (click)="menuSettings = true"></span>
                <div class="settings-dropdown-panel"
                    [ngClass]="{'show':menuSettings}">
                    <div class="settings-dropdown-title">
                        Menu Settings
                    </div>
                    <div class="settings-dropdown-body">
                        <ap-toggle (onChange)="switch($event)" [(ngModel)]="mSetting.showScreen" [ariaLabel]="'Show Screen'">
                            Show Screen
                        </ap-toggle>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom-scroll-container">
            <div class="expand-collapse-row">
                <div class="expand-collapse"
                    (click)="toggleAccordion(1)">
                    Expand All / Collapse All
                </div>
            </div>
            <div class="custom-scroll">
                <gtw-sub-tasks-container
                    (showScreensEvent)="showScreens($event)" 
                    [task-list]="taskList" 
                    [tax-type-name]="domainName" 
                    [pannel-position]=1
                    [is-accordion-open]="isAccordion1Open"
                    (panelClose)="closeMenuPanel($event)" 
                    [m-setting]="mSetting">
                </gtw-sub-tasks-container>
            </div>
        </div>      
    </div>
}    
    
    @if (!isMenuPanelClosed) {
<div class="nav-panel screen-panel">   
        <div class="menuSearch">
            <span class="panel-title"> Categories </span>
        
            <div class="searchContainer">
                <ap-search
                    [searchType]="'secondary'"
                    [placeholder]="'Search'"
                    [filtered]="false"
                    [styleClass]="'gtw-nav-search'"
                    [ariaLabel]="'Search categories'"
                    [(ngModel)]="categoriesSearchTerm"
                    (onSearch)="onAppkitSearch($event, 'categories')"
                    (onKeydown)="onAppkitSearch($event, 'categories')"
                    (onClear)="onAppkitClear('categories')">
                </ap-search>
            </div>
        
            <span class="Appkit4-icon Appkit4-icon icon-circle-delete-outline cancelPanel" 
                  (click)="closeMenuPanel($event);">
            </span>
        </div>
        <div class="custom-scroll-container">
            <div class="expand-collapse-row">
                <div class="expand-collapse"
                    (click)="toggleAccordion(2)">
                    Expand All / Collapse All
                </div>
            </div>
            <div class="custom-scroll"> 
                <gtw-sub-tasks-container
                    (showScreensEvent)="showScreens($event)" 
                    [task-list]="categoriesList" 
                    [tax-type-name]="'Categories'" 
                    [pannel-position]=2
                    [is-accordion-open]="isAccordion2Open"
                    (panelClose)="closeMenuPanel($event)">
                </gtw-sub-tasks-container>
            </div>
        </div>
    </div>
}
</div>
